// extracted by mini-css-extract-plugin
module.exports = {"header-title":"HeaderTitle_header-title__3VVLQ","header-title__text":"HeaderTitle_header-title__text__cdthb","header-title__icon":"HeaderTitle_header-title__icon__37FfH"};